module.exports = __webpack_public_path__ + "img/slide-34.8c914d47.jpeg";